import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: Date; output: Date; }
};

/** An anomaly in a session. */
export type Anomaly = RelayNode & {
  __typename?: 'Anomaly';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The time the anomaly ended. */
  endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The global ID. */
  id: Scalars['ID']['output'];
  /** The kind of anomaly. */
  kind: AnomalyKindEnum;
  /** The photo comments for this anomaly. */
  photoComments: PhotoCommentConnection;
  /** The session for this anomaly. */
  session: Session;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** An anomaly in a session. */
export type AnomalyPhotoCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Available kinds of anomalies */
export enum AnomalyKindEnum {
  /** An anomaly which is absent */
  Absent = 'absent',
  /** An anomaly which is assistance */
  Assistance = 'assistance'
}

/** Details about an attache file */
export type AttacheFile = {
  __typename?: 'AttacheFile';
  /** The file size in bytes. */
  bytes: Scalars['Int']['output'];
  /** The file's MIME type. */
  contentType: Scalars['String']['output'];
  /** An image file's original geometry (i.e. 300x300). */
  geometry?: Maybe<Scalars['String']['output']>;
  /** A substring of the URL, relative to Attache's configured view URL. */
  path: Scalars['String']['output'];
  /** The attache server's signature of the file, verifying authenticity. */
  signature: Scalars['String']['output'];
  /** Where to access the file. */
  url: Scalars['String']['output'];
};

/** The params needed to upload a file to the Attache server. */
export type AttacheOptions = {
  __typename?: 'AttacheOptions';
  /** The base url where the file may be retrieved after upload via GET. */
  downloadurl: Scalars['String']['output'];
  /** Time that these credentials will no longer be valid (seconds since the epoch). */
  expiration: Scalars['Int']['output'];
  /** The geometry for this session. */
  geometry: Scalars['String']['output'];
  /** An authorization key for uploads to the Attache server. */
  hmac: Scalars['String']['output'];
  /** The url where the file should be uploaded via PUT. Add the other attributes here as url params as well as the filename using "file" as the param key. */
  uploadurl: Scalars['String']['output'];
  /** A randomly generated UUID. */
  uuid: Scalars['String']['output'];
};

/** Attributes needed to connect to a file uploaded to the attache file server */
export type AttacheUploadFile = {
  /** The size of the file, in bytes. */
  bytes: Scalars['Int']['input'];
  /** The MIME type of the file uploaded. */
  contentType: Scalars['String']['input'];
  /** If the file is an image; this is the image's original geometry (i.e. 300x300). */
  geometry?: InputMaybe<Scalars['String']['input']>;
  /** The URL path to the file on attache (following the configured download URL). */
  path: Scalars['String']['input'];
  /** A signature returned by the Attache server proving the validity of the attachment. */
  signature: Scalars['String']['input'];
  /** The URL for viewing this file. Not necessary for update but allowed for convenience. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** An attendance photo. */
export type AttendancePhoto = RelayNode & {
  __typename?: 'AttendancePhoto';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Whether the attendance photo is flagged. */
  flagged: Scalars['Boolean']['output'];
  /** The global ID. */
  id: Scalars['ID']['output'];
  /** The photo itself. */
  photo?: Maybe<AttacheFile>;
  /** The photo comments for this attendance photo. */
  photoComments: Array<PhotoComment>;
  /** The session for this attendance photo. */
  session: Session;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** An attendance photo. */
export type AttendancePhotoPhotoArgs = {
  geometry?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for AttendancePhoto. */
export type AttendancePhotoConnection = {
  __typename?: 'AttendancePhotoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AttendancePhotoEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<AttendancePhoto>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AttendancePhotoEdge = {
  __typename?: 'AttendancePhotoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AttendancePhoto>;
};

/** Find attendance photos. */
export type AttendancePhotosNamespace = {
  __typename?: 'AttendancePhotosNamespace';
  /** Find a single attendancephoto by its string ID. */
  findById?: Maybe<AttendancePhoto>;
};


/** Find attendance photos. */
export type AttendancePhotosNamespaceFindByIdArgs = {
  id: Scalars['ID']['input'];
};

export type AutomatedAttendanceOptions = {
  __typename?: 'AutomatedAttendanceOptions';
  /** The maximum absent for this session. */
  maximumAbsent?: Maybe<Scalars['Int']['output']>;
  /** The maximum assistance for this session. */
  maximumAssistance?: Maybe<Scalars['Int']['output']>;
  /** The minimum time for this session. */
  minimumTime?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of CancelIDV */
export type CancelIdvInput = {
  /** The ID of the learner on the integrated application. */
  appId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CancelIDV. */
export type CancelIdvPayload = {
  __typename?: 'CancelIDVPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The learner with identity verification initiated. */
  learner?: Maybe<Learner>;
};

/** Autogenerated input type of ClaimSession */
export type ClaimSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the session to claim. */
  sessionId: Scalars['ID']['input'];
};

/** Autogenerated return type of ClaimSession. */
export type ClaimSessionPayload = {
  __typename?: 'ClaimSessionPayload';
  /** The claimed session. */
  claimedSession: Session;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The errors that occurred while claiming the session. */
  errors?: Maybe<Array<ValidationError>>;
};

/** Autogenerated input type of CreateIDV */
export type CreateIdvInput = {
  /** The ID of the learner on the integrated application. */
  appId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email of the learner. */
  email: Scalars['String']['input'];
  /** The first name of the learner. */
  firstName: Scalars['String']['input'];
  /** The last name of the learner. */
  lastName: Scalars['String']['input'];
};

/** Autogenerated return type of CreateIDV. */
export type CreateIdvPayload = {
  __typename?: 'CreateIDVPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The learner with identity verification initiated. */
  learner?: Maybe<Learner>;
};

export type CreatePhotoCommentAttributes = {
  /** The comment to create for the attendance photo. */
  comment: Scalars['String']['input'];
  /** The ID of the session to create a photo comment for. */
  sessionId: Scalars['ID']['input'];
};

/** Autogenerated input type of CreatePhotoComment */
export type CreatePhotoCommentInput = {
  /** The ID of the attendance photo to create a photo comment for. */
  attendancePhotoId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes needed to create a photo comment. */
  photoComment: CreatePhotoCommentAttributes;
};

/** Autogenerated return type of CreatePhotoComment. */
export type CreatePhotoCommentPayload = {
  __typename?: 'CreatePhotoCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created photo comment. */
  photoComment?: Maybe<PhotoComment>;
};

export type CreateRetakeRequestAttributes = {
  /** Whether the face photo should be retaken. */
  facePhoto: Scalars['Boolean']['input'];
  /** The reason the face photo should be retaken. */
  facePhotoReason?: InputMaybe<Scalars['String']['input']>;
  /** Whether the ID photo should be retaken. */
  idPhoto: Scalars['Boolean']['input'];
  /** The reason the ID photo should be retaken. */
  idPhotoReason?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of CreateRetakeRequest */
export type CreateRetakeRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes needed to create a retake request. */
  retakeRequest: CreateRetakeRequestAttributes;
  /** The ID of the session to create a retake request. */
  sessionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateRetakeRequest. */
export type CreateRetakeRequestPayload = {
  __typename?: 'CreateRetakeRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created Retake Request. */
  retakeRequest?: Maybe<RetakeRequest>;
};

export type CreateVerificationAttributes = {
  /** The reason to create a verification. */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** The service to create a verification. */
  service: VerificationServiceEnum;
  /** The status to create a verification. */
  status: VerificationStatusEnum;
};

/** Autogenerated input type of CreateVerification */
export type CreateVerificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the session to create a verification. */
  sessionId: Scalars['ID']['input'];
  /** Attributes needed to create a verification. */
  verification: CreateVerificationAttributes;
};

/** Autogenerated return type of CreateVerification. */
export type CreateVerificationPayload = {
  __typename?: 'CreateVerificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The newly created Verification. */
  verification?: Maybe<Verification>;
};

/** Available kinds of anomalies */
export enum EncryptorNameEnum {
  /** Encryptor for retake request sessions. */
  RetakeRequests = 'retake_requests',
  /** Encryptor for review sessions. */
  Review = 'review'
}

/** An event in a session. */
export type Event = RelayNode & {
  __typename?: 'Event';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The global ID. */
  id: Scalars['ID']['output'];
  /** The session for this event. */
  session: Session;
  /** The title of the event. */
  title: Scalars['String']['output'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The possible identity verification statuses of a learner. */
export enum IdvStatusEnum {
  /** An identity verification which is cancelled */
  Cancelled = 'cancelled',
  /** An identity verification which is created */
  Created = 'created',
  /** An identity verification which is failed */
  Failed = 'failed',
  /** An identity verification which is verified */
  Verified = 'verified'
}

/** An Identification. */
export type Identification = RelayNode & {
  __typename?: 'Identification';
  /** The comment for this identification. */
  comment?: Maybe<Scalars['String']['output']>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The face photo for this identification. */
  facePhoto?: Maybe<AttacheFile>;
  /** The global ID. */
  id: Scalars['ID']['output'];
  /** The ID photo for this identification. */
  idPhoto?: Maybe<AttacheFile>;
  /** The learner for this identification. */
  learner: Learner;
  /** The session for this identification. */
  session?: Maybe<Session>;
  /** The status of this identification. */
  status: IdentificationStatusEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** An Identification. */
export type IdentificationFacePhotoArgs = {
  geometry?: InputMaybe<Scalars['String']['input']>;
};


/** An Identification. */
export type IdentificationIdPhotoArgs = {
  geometry?: InputMaybe<Scalars['String']['input']>;
};

/** Available statuses for an identification */
export enum IdentificationStatusEnum {
  /** An identification which is failed */
  Failed = 'failed',
  /** An identification which is passed */
  Passed = 'passed',
  /** An identification which is pending */
  Pending = 'pending'
}

/** A learner. */
export type Learner = RelayNode & {
  __typename?: 'Learner';
  /** The ID of the learner on the integrated application. */
  appId: Scalars['String']['output'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The email of the learner. */
  email?: Maybe<Scalars['String']['output']>;
  /** The global ID. */
  id: Scalars['ID']['output'];
  /** The status of the identity verification for the learner. */
  idvStatus?: Maybe<IdvStatusEnum>;
  /** The name of the learner. */
  name: Scalars['String']['output'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Cancel a pending identity verification for a learner. */
  cancelIdv?: Maybe<CancelIdvPayload>;
  /** Claim a session for the current user. */
  claimSession?: Maybe<ClaimSessionPayload>;
  /** Create an identity verification for a learner. */
  createIdv?: Maybe<CreateIdvPayload>;
  /** Create a photo comment for an attendance photo. */
  createPhotoComment?: Maybe<CreatePhotoCommentPayload>;
  /** Create a retake request for a session. */
  createRetakeRequest?: Maybe<CreateRetakeRequestPayload>;
  /** Create a verification for a session. */
  createVerification?: Maybe<CreateVerificationPayload>;
  /** Retake photos for a session. */
  retakePhotos?: Maybe<RetakePhotosPayload>;
};


export type MutationCancelIdvArgs = {
  input: CancelIdvInput;
};


export type MutationClaimSessionArgs = {
  input: ClaimSessionInput;
};


export type MutationCreateIdvArgs = {
  input: CreateIdvInput;
};


export type MutationCreatePhotoCommentArgs = {
  input: CreatePhotoCommentInput;
};


export type MutationCreateRetakeRequestArgs = {
  input: CreateRetakeRequestInput;
};


export type MutationCreateVerificationArgs = {
  input: CreateVerificationInput;
};


export type MutationRetakePhotosArgs = {
  input: RetakePhotosInput;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** A comment flagging an attendance photo. */
export type PhotoComment = RelayNode & {
  __typename?: 'PhotoComment';
  /** The attendance photo for this photo comment. */
  attendancePhoto: AttendancePhoto;
  /** The comment itself. */
  comment: Scalars['String']['output'];
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The global ID. */
  id: Scalars['ID']['output'];
  /** The photo itself. */
  photo?: Maybe<AttacheFile>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};


/** A comment flagging an attendance photo. */
export type PhotoCommentPhotoArgs = {
  geometry?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for PhotoComment. */
export type PhotoCommentConnection = {
  __typename?: 'PhotoCommentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PhotoCommentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PhotoComment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PhotoCommentEdge = {
  __typename?: 'PhotoCommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PhotoComment>;
};

/** Public queries. */
export type PublicNamespace = {
  __typename?: 'PublicNamespace';
  /** Get the domain to set the cookie when sharing info with the Angular app and the API. */
  cookieDomain?: Maybe<Scalars['String']['output']>;
  /** Find sessions from an encrypted token. */
  sessionsFromEncryptedToken?: Maybe<Array<Session>>;
};


/** Public queries. */
export type PublicNamespaceSessionsFromEncryptedTokenArgs = {
  encryptor: EncryptorNameEnum;
  token: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  /** The attendance photos. */
  attendancePhotos?: Maybe<AttendancePhotosNamespace>;
  /** Get the current authenticated user */
  currentUser?: Maybe<User>;
  /** Public queries. */
  public?: Maybe<PublicNamespace>;
  /** The Learner Verified sessions. */
  sessions?: Maybe<SessionsNamespace>;
};

export type RelayNode = {
  /** The global ID. */
  id: Scalars['ID']['output'];
};

export type RetakePhotosAttributes = {
  /** The retaken face photo. */
  facePhoto?: InputMaybe<AttacheUploadFile>;
  /** The retaken ID photo. */
  idPhoto?: InputMaybe<AttacheUploadFile>;
};

/** Autogenerated input type of RetakePhotos */
export type RetakePhotosInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Attributes needed to retake photos. */
  retakePhotos: RetakePhotosAttributes;
  /** The encrypted token containing the session id. */
  token: Scalars['String']['input'];
};

/** Autogenerated return type of RetakePhotos. */
export type RetakePhotosPayload = {
  __typename?: 'RetakePhotosPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Any validation errors returned. */
  errors: Array<ValidationError>;
  /** The session with the retaken photos. */
  retakenSession?: Maybe<Session>;
};

/** A request to retake I.D. photo(s). */
export type RetakeRequest = RelayNode & {
  __typename?: 'RetakeRequest';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Whether the face photo should be retaken. */
  facePhoto: Scalars['Boolean']['output'];
  /** The reason the face photo should be retaken. */
  facePhotoReason?: Maybe<Scalars['String']['output']>;
  /** The global ID. */
  id: Scalars['ID']['output'];
  /** Whether the ID photo should be retaken. */
  idPhoto: Scalars['Boolean']['output'];
  /** The reason the ID photo should be retaken. */
  idPhotoReason?: Maybe<Scalars['String']['output']>;
  /** The most recent retake request for this session. */
  retakeRequest: RetakeRequest;
  /** All retake requests for this session. */
  retakeRequests: Array<RetakeRequest>;
  /** The date and time the retake request was retaken. */
  retakenAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The session for this retake request. */
  session: Session;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ServiceOptions = {
  __typename?: 'ServiceOptions';
  /** The automated attendance options for this session. */
  automatedAttendance?: Maybe<AutomatedAttendanceOptions>;
};

/** A Learner Verified session. */
export type Session = RelayNode & {
  __typename?: 'Session';
  /** The active identification for this session. */
  activeIdentification?: Maybe<Identification>;
  /** The anomalies for this session. */
  anomalies: Array<Anomaly>;
  /** The attache options for this session. */
  attacheOptions: AttacheOptions;
  /** The attendance photos for this session. */
  attendancePhotos: AttendancePhotoConnection;
  /** The status of the attendance verification. */
  attendanceVerificationStatus: VerificationStatusEnum;
  /** Any permissions you have relevant to the Session. */
  can: SessionPermissions;
  /** The date and time the session was claimed. */
  claimedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The user who claimed this session. */
  claimedBy?: Maybe<User>;
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The domain based on the URL. */
  domain: Scalars['String']['output'];
  /** The duration of the session. */
  duration: Scalars['Int']['output'];
  /** The events for this session. */
  events: Array<Event>;
  /** Whether the session has been failed. */
  failed: Scalars['Boolean']['output'];
  /** Whether the session has been finished. */
  finished: Scalars['Boolean']['output'];
  /** The date and time the session was finished. */
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The global ID. */
  id: Scalars['ID']['output'];
  /** Whether the ID has been verified. */
  idVerified: Scalars['Boolean']['output'];
  /** The identification for this session. */
  identification?: Maybe<Identification>;
  /** The learner for this session. */
  learner: Learner;
  /** Whether the session is live. */
  live: Scalars['Boolean']['output'];
  /** Whether the session is live agent. */
  liveAgent: Scalars['Boolean']['output'];
  /** The name of the course for this session. */
  name: Scalars['String']['output'];
  /** Whether the session has been passed. */
  passed: Scalars['Boolean']['output'];
  /** Whether the session requires identification. */
  requiresIdentification: Scalars['Boolean']['output'];
  /** The retake request for this session. */
  retakeRequest?: Maybe<RetakeRequest>;
  /** The retake requests for this session. */
  retakeRequests: Array<RetakeRequest>;
  /** The service options for this session. */
  serviceOptions: ServiceOptions;
  /** The services that are available for this session. */
  services: Array<SessionServicesEnum>;
  /** The date and time the session was started. */
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The status of the session. */
  status: SessionStatusEnum;
  /** The tokbox for this session. */
  tokbox?: Maybe<Tokbox>;
  /** The token for this session. */
  token: Scalars['String']['output'];
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The URL of the course item for this session. */
  url: Scalars['String']['output'];
  /** The verifications for this session. */
  verifications: Array<Verification>;
};


/** A Learner Verified session. */
export type SessionAttendancePhotosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Session. */
export type SessionConnection = {
  __typename?: 'SessionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SessionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Session>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SessionEdge = {
  __typename?: 'SessionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Session>;
};

/** Permissions for a Session. */
export type SessionPermissions = {
  __typename?: 'SessionPermissions';
  /** Whether the current user can claim this session. */
  claim: Scalars['Boolean']['output'];
  /** The ID of the record these permissions are for. */
  id: Scalars['ID']['output'];
  /** Whether the current user can pass this session. */
  pass: Scalars['Boolean']['output'];
  /** Whether the current user can view this session. */
  show: Scalars['Boolean']['output'];
  /** Whether the current user can verify this session. */
  verify: Scalars['Boolean']['output'];
};

/** Available services for a session */
export enum SessionServicesEnum {
  /** Automated attendances */
  AutomatedAttendance = 'automated_attendance',
  /** Live ID verifications */
  LiveIdVerification = 'live_id_verification',
  /** Offline attendances */
  OfflineAttendance = 'offline_attendance',
  /** Offline ID verifications */
  OfflineIdVerification = 'offline_id_verification'
}

/** Available services for a session */
export enum SessionStatusEnum {
  /** A session which is Failed */
  Failed = 'failed',
  /** A session which is Passed */
  Passed = 'passed',
  /** A session which is Pending */
  Pending = 'pending'
}

/** Find Learner Verified sessions. */
export type SessionsNamespace = {
  __typename?: 'SessionsNamespace';
  /** Find a single session by its string ID. */
  findById?: Maybe<Session>;
  /** Get all Learner Verified Sessions with live ID verification pending. */
  forDashboardWithLiveId: SessionConnection;
  /** Get all Learner Verified Sessions with offline ID verification pending. */
  forDashboardWithOfflineId: SessionConnection;
  /** Get all Learner Verified Sessions with pending retake requests. */
  forDashboardWithPendingRetakeRequests: SessionConnection;
  /** Get all Learner Verified Sessions with retaken requests. */
  forDashboardWithRetakenRequests: SessionConnection;
};


/** Find Learner Verified sessions. */
export type SessionsNamespaceFindByIdArgs = {
  id: Scalars['ID']['input'];
};


/** Find Learner Verified sessions. */
export type SessionsNamespaceForDashboardWithLiveIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Find Learner Verified sessions. */
export type SessionsNamespaceForDashboardWithOfflineIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Find Learner Verified sessions. */
export type SessionsNamespaceForDashboardWithPendingRetakeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Find Learner Verified sessions. */
export type SessionsNamespaceForDashboardWithRetakenRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type Tokbox = {
  __typename?: 'Tokbox';
  /** The API key for this session. */
  apiKey: Scalars['String']['output'];
  /** The session ID for this session. */
  sessionId: Scalars['String']['output'];
  /** The token for this session. */
  token: Scalars['String']['output'];
};

/** A system user. */
export type User = RelayNode & {
  __typename?: 'User';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The email of the user. */
  email: Scalars['String']['output'];
  /** The global ID. */
  id: Scalars['ID']['output'];
  /** The name of the user. */
  name?: Maybe<Scalars['String']['output']>;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A validation error. */
export type ValidationError = {
  __typename?: 'ValidationError';
  /** The attribute that has the problem. */
  attribute?: Maybe<Scalars['String']['output']>;
  /** The human description of what went wrong. */
  message: Scalars['String']['output'];
};

/** A verification. */
export type Verification = RelayNode & {
  __typename?: 'Verification';
  /** When the record was created. */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The global ID. */
  id: Scalars['ID']['output'];
  /** The reason for this verification. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The service for this verification. */
  service: VerificationServiceEnum;
  /** The session for this verification. */
  session: Session;
  /** The status for this verification. */
  status: VerificationStatusEnum;
  /** When the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The user for this verification. */
  user?: Maybe<User>;
};

/** Available services for a verification. */
export enum VerificationServiceEnum {
  /** A verification which is attendance */
  Attendance = 'attendance',
  /** A verification which is identification */
  Identification = 'identification'
}

/** Available statuses for a verification. */
export enum VerificationStatusEnum {
  /** A verification which is failed */
  Failed = 'failed',
  /** A verification which is passed */
  Passed = 'passed',
  /** A verification which is pending */
  Pending = 'pending'
}

export type AttendancePhotoPartsFragment = { __typename?: 'AttendancePhoto', id: string, flagged: boolean, createdAt: Date, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, photoComments: Array<{ __typename?: 'PhotoComment', id: string, comment: string, createdAt: Date, attendancePhoto: { __typename?: 'AttendancePhoto', id: string } }> };

export type AttendancePhotosForSessionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AttendancePhotosForSessionQueryResult = { __typename?: 'Query', sessions?: { __typename?: 'SessionsNamespace', findById?: { __typename?: 'Session', id: string, attendancePhotos: { __typename?: 'AttendancePhotoConnection', nodes?: Array<{ __typename?: 'AttendancePhoto', id: string, flagged: boolean, createdAt: Date, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, photoComments: Array<{ __typename?: 'PhotoComment', id: string, comment: string, createdAt: Date, attendancePhoto: { __typename?: 'AttendancePhoto', id: string } }> } | null> | null } } | null } | null };

export type FindAttendancePhotoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FindAttendancePhotoQueryResult = { __typename?: 'Query', attendancePhotos?: { __typename?: 'AttendancePhotosNamespace', findById?: { __typename?: 'AttendancePhoto', id: string, flagged: boolean, createdAt: Date, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, photoComments: Array<{ __typename?: 'PhotoComment', id: string, comment: string, createdAt: Date, attendancePhoto: { __typename?: 'AttendancePhoto', id: string } }> } | null } | null };

export type FilePartsFragment = { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string };

export type CookieDomainQueryVariables = Exact<{ [key: string]: never; }>;


export type CookieDomainQueryResult = { __typename?: 'Query', public?: { __typename?: 'PublicNamespace', cookieDomain?: string | null } | null };

export type IdentificationPartsFragment = { __typename?: 'Identification', id: string, status: IdentificationStatusEnum, comment?: string | null, facePhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, idPhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null };

export type CreatePhotoCommentMutationVariables = Exact<{
  input: CreatePhotoCommentInput;
}>;


export type CreatePhotoCommentMutationResult = { __typename?: 'Mutation', createPhotoComment?: { __typename?: 'CreatePhotoCommentPayload', photoComment?: { __typename?: 'PhotoComment', id: string, comment: string, createdAt: Date, attendancePhoto: { __typename?: 'AttendancePhoto', id: string } } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type PhotoCommentPartsFragment = { __typename?: 'PhotoComment', id: string, comment: string, createdAt: Date, attendancePhoto: { __typename?: 'AttendancePhoto', id: string } };

export type CreateRetakeRequestMutationVariables = Exact<{
  input: CreateRetakeRequestInput;
}>;


export type CreateRetakeRequestMutationResult = { __typename?: 'Mutation', createRetakeRequest?: { __typename?: 'CreateRetakeRequestPayload', retakeRequest?: { __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null, facePhoto: boolean, idPhoto: boolean, facePhotoReason?: string | null, idPhotoReason?: string | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type RetakeRequestPartsFragment = { __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null, facePhoto: boolean, idPhoto: boolean, facePhotoReason?: string | null, idPhotoReason?: string | null };

export type ClaimSessionMutationVariables = Exact<{
  input: ClaimSessionInput;
}>;


export type ClaimSessionMutationResult = { __typename?: 'Mutation', claimSession?: { __typename?: 'ClaimSessionPayload', claimedSession: { __typename?: 'Session', id: string, name: string, url: string, services: Array<SessionServicesEnum>, status: SessionStatusEnum, token: string, domain: string, createdAt: Date, finishedAt?: Date | null, claimedBy?: { __typename?: 'User', id: string, email: string, name?: string | null } | null, learner: { __typename?: 'Learner', id: string, appId: string, email?: string | null, name: string }, retakeRequest?: { __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null } | null }, errors?: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> | null } | null };

export type DashboardListSessionPartsFragment = { __typename?: 'Session', id: string, name: string, url: string, services: Array<SessionServicesEnum>, status: SessionStatusEnum, token: string, domain: string, createdAt: Date, finishedAt?: Date | null, claimedBy?: { __typename?: 'User', id: string, email: string, name?: string | null } | null, learner: { __typename?: 'Learner', id: string, appId: string, email?: string | null, name: string }, retakeRequest?: { __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null } | null };

export type FindSessionByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type FindSessionByIdQueryResult = { __typename?: 'Query', sessions?: { __typename?: 'SessionsNamespace', findById?: { __typename?: 'Session', id: string, name: string, url: string, services: Array<SessionServicesEnum>, status: SessionStatusEnum, token: string, domain: string, duration: number, attendanceVerificationStatus: VerificationStatusEnum, idVerified: boolean, passed: boolean, failed: boolean, finished: boolean, live: boolean, liveAgent: boolean, requiresIdentification: boolean, startedAt?: Date | null, createdAt: Date, finishedAt?: Date | null, can: { __typename?: 'SessionPermissions', show: boolean, verify: boolean, pass: boolean, claim: boolean }, claimedBy?: { __typename?: 'User', id: string, email: string, name?: string | null } | null, learner: { __typename?: 'Learner', id: string, appId: string, email?: string | null, name: string }, identification?: { __typename?: 'Identification', id: string, status: IdentificationStatusEnum, comment?: string | null, facePhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, idPhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null } | null, activeIdentification?: { __typename?: 'Identification', id: string, status: IdentificationStatusEnum, comment?: string | null, facePhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, idPhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null } | null, verifications: Array<{ __typename?: 'Verification', id: string, service: VerificationServiceEnum, status: VerificationStatusEnum, reason?: string | null }>, serviceOptions: { __typename?: 'ServiceOptions', automatedAttendance?: { __typename?: 'AutomatedAttendanceOptions', minimumTime?: number | null, maximumAbsent?: number | null, maximumAssistance?: number | null } | null }, tokbox?: { __typename?: 'Tokbox', sessionId: string, apiKey: string, token: string } | null, attacheOptions: { __typename?: 'AttacheOptions', downloadurl: string, expiration: number, geometry: string, hmac: string, uploadurl: string, uuid: string }, anomalies: Array<{ __typename?: 'Anomaly', id: string, kind: AnomalyKindEnum, createdAt: Date, endedAt?: Date | null, photoComments: { __typename?: 'PhotoCommentConnection', nodes?: Array<{ __typename?: 'PhotoComment', id: string, comment: string, createdAt: Date, attendancePhoto: { __typename?: 'AttendancePhoto', id: string } } | null> | null } }>, events: Array<{ __typename?: 'Event', id: string, title: string, createdAt: Date }>, attendancePhotos: { __typename?: 'AttendancePhotoConnection', nodes?: Array<{ __typename?: 'AttendancePhoto', id: string, flagged: boolean, createdAt: Date, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, photoComments: Array<{ __typename?: 'PhotoComment', id: string, comment: string, createdAt: Date, attendancePhoto: { __typename?: 'AttendancePhoto', id: string } }> } | null> | null }, retakeRequest?: { __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null, facePhoto: boolean, idPhoto: boolean, facePhotoReason?: string | null, idPhotoReason?: string | null } | null, retakeRequests: Array<{ __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null, facePhoto: boolean, idPhoto: boolean, facePhotoReason?: string | null, idPhotoReason?: string | null }> } | null } | null };

export type SessionsForDashboardWithLiveIdQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SessionsForDashboardWithLiveIdQueryResult = { __typename?: 'Query', sessions?: { __typename?: 'SessionsNamespace', forDashboardWithLiveId: { __typename?: 'SessionConnection', nodes?: Array<{ __typename?: 'Session', id: string, name: string, url: string, services: Array<SessionServicesEnum>, status: SessionStatusEnum, token: string, domain: string, createdAt: Date, finishedAt?: Date | null, claimedBy?: { __typename?: 'User', id: string, email: string, name?: string | null } | null, learner: { __typename?: 'Learner', id: string, appId: string, email?: string | null, name: string }, retakeRequest?: { __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type SessionsForDashboardWithOfflineIdQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SessionsForDashboardWithOfflineIdQueryResult = { __typename?: 'Query', sessions?: { __typename?: 'SessionsNamespace', forDashboardWithOfflineId: { __typename?: 'SessionConnection', nodes?: Array<{ __typename?: 'Session', id: string, name: string, url: string, services: Array<SessionServicesEnum>, status: SessionStatusEnum, token: string, domain: string, createdAt: Date, finishedAt?: Date | null, claimedBy?: { __typename?: 'User', id: string, email: string, name?: string | null } | null, learner: { __typename?: 'Learner', id: string, appId: string, email?: string | null, name: string }, retakeRequest?: { __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type SessionsForDashboardWithPendingRetakeRequestsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SessionsForDashboardWithPendingRetakeRequestsQueryResult = { __typename?: 'Query', sessions?: { __typename?: 'SessionsNamespace', forDashboardWithPendingRetakeRequests: { __typename?: 'SessionConnection', nodes?: Array<{ __typename?: 'Session', id: string, name: string, url: string, services: Array<SessionServicesEnum>, status: SessionStatusEnum, token: string, domain: string, createdAt: Date, finishedAt?: Date | null, claimedBy?: { __typename?: 'User', id: string, email: string, name?: string | null } | null, learner: { __typename?: 'Learner', id: string, appId: string, email?: string | null, name: string }, retakeRequest?: { __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type SessionsForDashboardWithRetakenRequestsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SessionsForDashboardWithRetakenRequestsQueryResult = { __typename?: 'Query', sessions?: { __typename?: 'SessionsNamespace', forDashboardWithRetakenRequests: { __typename?: 'SessionConnection', nodes?: Array<{ __typename?: 'Session', id: string, name: string, url: string, services: Array<SessionServicesEnum>, status: SessionStatusEnum, token: string, domain: string, createdAt: Date, finishedAt?: Date | null, claimedBy?: { __typename?: 'User', id: string, email: string, name?: string | null } | null, learner: { __typename?: 'Learner', id: string, appId: string, email?: string | null, name: string }, retakeRequest?: { __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type LoadSimplifiedSessionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type LoadSimplifiedSessionQueryResult = { __typename?: 'Query', sessions?: { __typename?: 'SessionsNamespace', findById?: { __typename?: 'Session', id: string, name: string, url: string, services: Array<SessionServicesEnum>, status: SessionStatusEnum, token: string, domain: string, createdAt: Date, finishedAt?: Date | null, claimedBy?: { __typename?: 'User', id: string, email: string, name?: string | null } | null, learner: { __typename?: 'Learner', id: string, appId: string, email?: string | null, name: string }, retakeRequest?: { __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null } | null } | null } | null };

export type RetakePhotosMutationVariables = Exact<{
  input: RetakePhotosInput;
}>;


export type RetakePhotosMutationResult = { __typename?: 'Mutation', retakePhotos?: { __typename?: 'RetakePhotosPayload', retakenSession?: { __typename?: 'Session', id: string, retakeRequest?: { __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null, facePhoto: boolean, idPhoto: boolean, facePhotoReason?: string | null, idPhotoReason?: string | null } | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type SessionDetailsPartsFragment = { __typename?: 'Session', id: string, name: string, url: string, services: Array<SessionServicesEnum>, status: SessionStatusEnum, token: string, domain: string, duration: number, attendanceVerificationStatus: VerificationStatusEnum, idVerified: boolean, passed: boolean, failed: boolean, finished: boolean, live: boolean, liveAgent: boolean, requiresIdentification: boolean, startedAt?: Date | null, createdAt: Date, finishedAt?: Date | null, can: { __typename?: 'SessionPermissions', show: boolean, verify: boolean, pass: boolean, claim: boolean }, claimedBy?: { __typename?: 'User', id: string, email: string, name?: string | null } | null, learner: { __typename?: 'Learner', id: string, appId: string, email?: string | null, name: string }, identification?: { __typename?: 'Identification', id: string, status: IdentificationStatusEnum, comment?: string | null, facePhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, idPhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null } | null, activeIdentification?: { __typename?: 'Identification', id: string, status: IdentificationStatusEnum, comment?: string | null, facePhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, idPhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null } | null, verifications: Array<{ __typename?: 'Verification', id: string, service: VerificationServiceEnum, status: VerificationStatusEnum, reason?: string | null }>, serviceOptions: { __typename?: 'ServiceOptions', automatedAttendance?: { __typename?: 'AutomatedAttendanceOptions', minimumTime?: number | null, maximumAbsent?: number | null, maximumAssistance?: number | null } | null }, tokbox?: { __typename?: 'Tokbox', sessionId: string, apiKey: string, token: string } | null, attacheOptions: { __typename?: 'AttacheOptions', downloadurl: string, expiration: number, geometry: string, hmac: string, uploadurl: string, uuid: string }, anomalies: Array<{ __typename?: 'Anomaly', id: string, kind: AnomalyKindEnum, createdAt: Date, endedAt?: Date | null, photoComments: { __typename?: 'PhotoCommentConnection', nodes?: Array<{ __typename?: 'PhotoComment', id: string, comment: string, createdAt: Date, attendancePhoto: { __typename?: 'AttendancePhoto', id: string } } | null> | null } }>, events: Array<{ __typename?: 'Event', id: string, title: string, createdAt: Date }>, attendancePhotos: { __typename?: 'AttendancePhotoConnection', nodes?: Array<{ __typename?: 'AttendancePhoto', id: string, flagged: boolean, createdAt: Date, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, photoComments: Array<{ __typename?: 'PhotoComment', id: string, comment: string, createdAt: Date, attendancePhoto: { __typename?: 'AttendancePhoto', id: string } }> } | null> | null }, retakeRequest?: { __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null, facePhoto: boolean, idPhoto: boolean, facePhotoReason?: string | null, idPhotoReason?: string | null } | null, retakeRequests: Array<{ __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null, facePhoto: boolean, idPhoto: boolean, facePhotoReason?: string | null, idPhotoReason?: string | null }> };

export type SessionsFromEncryptedTokenQueryVariables = Exact<{
  token: Scalars['String']['input'];
  encryptor: EncryptorNameEnum;
}>;


export type SessionsFromEncryptedTokenQueryResult = { __typename?: 'Query', public?: { __typename?: 'PublicNamespace', sessionsFromEncryptedToken?: Array<{ __typename?: 'Session', id: string, name: string, url: string, services: Array<SessionServicesEnum>, status: SessionStatusEnum, token: string, domain: string, duration: number, attendanceVerificationStatus: VerificationStatusEnum, idVerified: boolean, passed: boolean, failed: boolean, finished: boolean, live: boolean, liveAgent: boolean, requiresIdentification: boolean, startedAt?: Date | null, createdAt: Date, finishedAt?: Date | null, can: { __typename?: 'SessionPermissions', show: boolean, verify: boolean, pass: boolean, claim: boolean }, claimedBy?: { __typename?: 'User', id: string, email: string, name?: string | null } | null, learner: { __typename?: 'Learner', id: string, appId: string, email?: string | null, name: string }, identification?: { __typename?: 'Identification', id: string, status: IdentificationStatusEnum, comment?: string | null, facePhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, idPhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null } | null, activeIdentification?: { __typename?: 'Identification', id: string, status: IdentificationStatusEnum, comment?: string | null, facePhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, idPhoto?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null } | null, verifications: Array<{ __typename?: 'Verification', id: string, service: VerificationServiceEnum, status: VerificationStatusEnum, reason?: string | null }>, serviceOptions: { __typename?: 'ServiceOptions', automatedAttendance?: { __typename?: 'AutomatedAttendanceOptions', minimumTime?: number | null, maximumAbsent?: number | null, maximumAssistance?: number | null } | null }, tokbox?: { __typename?: 'Tokbox', sessionId: string, apiKey: string, token: string } | null, attacheOptions: { __typename?: 'AttacheOptions', downloadurl: string, expiration: number, geometry: string, hmac: string, uploadurl: string, uuid: string }, anomalies: Array<{ __typename?: 'Anomaly', id: string, kind: AnomalyKindEnum, createdAt: Date, endedAt?: Date | null, photoComments: { __typename?: 'PhotoCommentConnection', nodes?: Array<{ __typename?: 'PhotoComment', id: string, comment: string, createdAt: Date, attendancePhoto: { __typename?: 'AttendancePhoto', id: string } } | null> | null } }>, events: Array<{ __typename?: 'Event', id: string, title: string, createdAt: Date }>, attendancePhotos: { __typename?: 'AttendancePhotoConnection', nodes?: Array<{ __typename?: 'AttendancePhoto', id: string, flagged: boolean, createdAt: Date, photo?: { __typename?: 'AttacheFile', bytes: number, contentType: string, geometry?: string | null, path: string, signature: string, url: string } | null, photoComments: Array<{ __typename?: 'PhotoComment', id: string, comment: string, createdAt: Date, attendancePhoto: { __typename?: 'AttendancePhoto', id: string } }> } | null> | null }, retakeRequest?: { __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null, facePhoto: boolean, idPhoto: boolean, facePhotoReason?: string | null, idPhotoReason?: string | null } | null, retakeRequests: Array<{ __typename?: 'RetakeRequest', id: string, createdAt: Date, retakenAt?: Date | null, facePhoto: boolean, idPhoto: boolean, facePhotoReason?: string | null, idPhotoReason?: string | null }> }> | null } | null };

export type CreateVerificationMutationVariables = Exact<{
  input: CreateVerificationInput;
}>;


export type CreateVerificationMutationResult = { __typename?: 'Mutation', createVerification?: { __typename?: 'CreateVerificationPayload', verification?: { __typename?: 'Verification', id: string, service: VerificationServiceEnum, status: VerificationStatusEnum, reason?: string | null, session: { __typename?: 'Session', id: string, passed: boolean, failed: boolean, finished: boolean, services: Array<SessionServicesEnum> }, user?: { __typename?: 'User', id: string } | null } | null, errors: Array<{ __typename?: 'ValidationError', attribute?: string | null, message: string }> } | null };

export type VerificationPartsFragment = { __typename?: 'Verification', id: string, service: VerificationServiceEnum, status: VerificationStatusEnum, reason?: string | null, session: { __typename?: 'Session', id: string, passed: boolean, failed: boolean, finished: boolean, services: Array<SessionServicesEnum> }, user?: { __typename?: 'User', id: string } | null };

export const DashboardListSessionPartsFragmentDoc = gql`
    fragment DashboardListSessionParts on Session {
  id
  name
  url
  services
  status
  token
  domain
  createdAt
  finishedAt
  claimedBy {
    id
    email
    name
  }
  learner {
    id
    appId
    email
    name
  }
  retakeRequest {
    id
    createdAt
    retakenAt
  }
}
    `;
export const FilePartsFragmentDoc = gql`
    fragment FileParts on AttacheFile {
  bytes
  contentType
  geometry
  path
  signature
  url
}
    `;
export const IdentificationPartsFragmentDoc = gql`
    fragment IdentificationParts on Identification {
  id
  status
  comment
  facePhoto {
    ...FileParts
  }
  idPhoto {
    ...FileParts
  }
}
    ${FilePartsFragmentDoc}`;
export const PhotoCommentPartsFragmentDoc = gql`
    fragment PhotoCommentParts on PhotoComment {
  id
  comment
  createdAt
  attendancePhoto {
    id
  }
}
    `;
export const AttendancePhotoPartsFragmentDoc = gql`
    fragment AttendancePhotoParts on AttendancePhoto {
  id
  flagged
  createdAt
  photo {
    ...FileParts
  }
  photoComments {
    ...PhotoCommentParts
  }
}
    ${FilePartsFragmentDoc}
${PhotoCommentPartsFragmentDoc}`;
export const RetakeRequestPartsFragmentDoc = gql`
    fragment RetakeRequestParts on RetakeRequest {
  id
  createdAt
  retakenAt
  facePhoto
  idPhoto
  facePhotoReason
  idPhotoReason
}
    `;
export const SessionDetailsPartsFragmentDoc = gql`
    fragment SessionDetailsParts on Session {
  id
  name
  url
  services
  status
  token
  domain
  duration
  attendanceVerificationStatus
  idVerified
  passed
  failed
  finished
  live
  liveAgent
  requiresIdentification
  startedAt
  createdAt
  finishedAt
  can {
    show
    verify
    pass
    claim
  }
  claimedBy {
    id
    email
    name
  }
  learner {
    id
    appId
    email
    name
  }
  identification {
    ...IdentificationParts
  }
  activeIdentification {
    ...IdentificationParts
  }
  verifications {
    id
    service
    status
    reason
  }
  serviceOptions {
    automatedAttendance {
      minimumTime
      maximumAbsent
      maximumAssistance
    }
  }
  tokbox {
    sessionId
    apiKey
    token
  }
  attacheOptions {
    downloadurl
    expiration
    geometry
    hmac
    uploadurl
    uuid
  }
  anomalies {
    id
    kind
    createdAt
    endedAt
    photoComments {
      nodes {
        ...PhotoCommentParts
      }
    }
  }
  events {
    id
    title
    createdAt
  }
  attendancePhotos {
    nodes {
      ...AttendancePhotoParts
    }
  }
  retakeRequest {
    ...RetakeRequestParts
  }
  retakeRequests {
    ...RetakeRequestParts
  }
}
    ${IdentificationPartsFragmentDoc}
${PhotoCommentPartsFragmentDoc}
${AttendancePhotoPartsFragmentDoc}
${RetakeRequestPartsFragmentDoc}`;
export const VerificationPartsFragmentDoc = gql`
    fragment VerificationParts on Verification {
  id
  service
  status
  reason
  session {
    id
    passed
    failed
    finished
    services
  }
  user {
    id
  }
}
    `;
export const AttendancePhotosForSessionDocument = gql`
    query AttendancePhotosForSession($id: ID!) {
  sessions {
    findById(id: $id) {
      id
      attendancePhotos {
        nodes {
          ...AttendancePhotoParts
        }
      }
    }
  }
}
    ${AttendancePhotoPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AttendancePhotosForSessionQuery extends Apollo.Query<AttendancePhotosForSessionQueryResult, AttendancePhotosForSessionQueryVariables> {
    document = AttendancePhotosForSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindAttendancePhotoDocument = gql`
    query FindAttendancePhoto($id: ID!) {
  attendancePhotos {
    findById(id: $id) {
      ...AttendancePhotoParts
    }
  }
}
    ${AttendancePhotoPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FindAttendancePhotoQuery extends Apollo.Query<FindAttendancePhotoQueryResult, FindAttendancePhotoQueryVariables> {
    document = FindAttendancePhotoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CookieDomainDocument = gql`
    query CookieDomain {
  public {
    cookieDomain
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CookieDomainQuery extends Apollo.Query<CookieDomainQueryResult, CookieDomainQueryVariables> {
    document = CookieDomainDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePhotoCommentDocument = gql`
    mutation CreatePhotoComment($input: CreatePhotoCommentInput!) {
  createPhotoComment(input: $input) {
    photoComment {
      ...PhotoCommentParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${PhotoCommentPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePhotoCommentMutation extends Apollo.Mutation<CreatePhotoCommentMutationResult, CreatePhotoCommentMutationVariables> {
    document = CreatePhotoCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRetakeRequestDocument = gql`
    mutation CreateRetakeRequest($input: CreateRetakeRequestInput!) {
  createRetakeRequest(input: $input) {
    retakeRequest {
      ...RetakeRequestParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${RetakeRequestPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRetakeRequestMutation extends Apollo.Mutation<CreateRetakeRequestMutationResult, CreateRetakeRequestMutationVariables> {
    document = CreateRetakeRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClaimSessionDocument = gql`
    mutation ClaimSession($input: ClaimSessionInput!) {
  claimSession(input: $input) {
    claimedSession {
      ...DashboardListSessionParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${DashboardListSessionPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ClaimSessionMutation extends Apollo.Mutation<ClaimSessionMutationResult, ClaimSessionMutationVariables> {
    document = ClaimSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindSessionByIdDocument = gql`
    query FindSessionById($id: ID!) {
  sessions {
    findById(id: $id) {
      ...SessionDetailsParts
    }
  }
}
    ${SessionDetailsPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FindSessionByIdQuery extends Apollo.Query<FindSessionByIdQueryResult, FindSessionByIdQueryVariables> {
    document = FindSessionByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SessionsForDashboardWithLiveIdDocument = gql`
    query SessionsForDashboardWithLiveId($after: String, $first: Int) {
  sessions {
    forDashboardWithLiveId(after: $after, first: $first) {
      nodes {
        ...DashboardListSessionParts
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${DashboardListSessionPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SessionsForDashboardWithLiveIdQuery extends Apollo.Query<SessionsForDashboardWithLiveIdQueryResult, SessionsForDashboardWithLiveIdQueryVariables> {
    document = SessionsForDashboardWithLiveIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SessionsForDashboardWithOfflineIdDocument = gql`
    query SessionsForDashboardWithOfflineId($after: String, $first: Int) {
  sessions {
    forDashboardWithOfflineId(after: $after, first: $first) {
      nodes {
        ...DashboardListSessionParts
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${DashboardListSessionPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SessionsForDashboardWithOfflineIdQuery extends Apollo.Query<SessionsForDashboardWithOfflineIdQueryResult, SessionsForDashboardWithOfflineIdQueryVariables> {
    document = SessionsForDashboardWithOfflineIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SessionsForDashboardWithPendingRetakeRequestsDocument = gql`
    query SessionsForDashboardWithPendingRetakeRequests($after: String, $first: Int) {
  sessions {
    forDashboardWithPendingRetakeRequests(after: $after, first: $first) {
      nodes {
        ...DashboardListSessionParts
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${DashboardListSessionPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SessionsForDashboardWithPendingRetakeRequestsQuery extends Apollo.Query<SessionsForDashboardWithPendingRetakeRequestsQueryResult, SessionsForDashboardWithPendingRetakeRequestsQueryVariables> {
    document = SessionsForDashboardWithPendingRetakeRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SessionsForDashboardWithRetakenRequestsDocument = gql`
    query SessionsForDashboardWithRetakenRequests($after: String, $first: Int) {
  sessions {
    forDashboardWithRetakenRequests(after: $after, first: $first) {
      nodes {
        ...DashboardListSessionParts
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${DashboardListSessionPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SessionsForDashboardWithRetakenRequestsQuery extends Apollo.Query<SessionsForDashboardWithRetakenRequestsQueryResult, SessionsForDashboardWithRetakenRequestsQueryVariables> {
    document = SessionsForDashboardWithRetakenRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoadSimplifiedSessionDocument = gql`
    query LoadSimplifiedSession($id: ID!) {
  sessions {
    findById(id: $id) {
      ...DashboardListSessionParts
    }
  }
}
    ${DashboardListSessionPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoadSimplifiedSessionQuery extends Apollo.Query<LoadSimplifiedSessionQueryResult, LoadSimplifiedSessionQueryVariables> {
    document = LoadSimplifiedSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RetakePhotosDocument = gql`
    mutation RetakePhotos($input: RetakePhotosInput!) {
  retakePhotos(input: $input) {
    retakenSession {
      id
      retakeRequest {
        ...RetakeRequestParts
      }
    }
    errors {
      attribute
      message
    }
  }
}
    ${RetakeRequestPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RetakePhotosMutation extends Apollo.Mutation<RetakePhotosMutationResult, RetakePhotosMutationVariables> {
    document = RetakePhotosDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SessionsFromEncryptedTokenDocument = gql`
    query SessionsFromEncryptedToken($token: String!, $encryptor: EncryptorNameEnum!) {
  public {
    sessionsFromEncryptedToken(token: $token, encryptor: $encryptor) {
      ...SessionDetailsParts
    }
  }
}
    ${SessionDetailsPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SessionsFromEncryptedTokenQuery extends Apollo.Query<SessionsFromEncryptedTokenQueryResult, SessionsFromEncryptedTokenQueryVariables> {
    document = SessionsFromEncryptedTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateVerificationDocument = gql`
    mutation CreateVerification($input: CreateVerificationInput!) {
  createVerification(input: $input) {
    verification {
      ...VerificationParts
    }
    errors {
      attribute
      message
    }
  }
}
    ${VerificationPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateVerificationMutation extends Apollo.Mutation<CreateVerificationMutationResult, CreateVerificationMutationVariables> {
    document = CreateVerificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "RelayNode": [
      "Anomaly",
      "AttendancePhoto",
      "Event",
      "Identification",
      "Learner",
      "PhotoComment",
      "RetakeRequest",
      "Session",
      "User",
      "Verification"
    ]
  }
};
      export default result;
    